import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderIntercomCommon = {
  key: 'intercom',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'intercom',
    authUrl: 'https://app.intercom.com/oauth',
    tokenUrl: 'https://api.intercom.io/auth/eagle/token',
    scopes: [],
  }),
}

export type ProviderIntercomAccountType = {
  input: {
    region: string
  }
}
